<template>
  <div class="page">
    <div class="titleLine">
      <div class="title">商品编辑</div>
      <div class="titleR">
        <div class="back" @click="$router.back()">返回</div>
      </div>
    </div>
    <div class="content">
      <div class="inputBox_title">基本信息</div>
      <div class="inputBox">
        <div class="inputLine">
          <div class="label">商品名称：{{ onlineName }}</div>
        </div>
        <div class="inputLine" style="margin: 0">
          <div class="label">品牌：{{ brand }}</div>
        </div>
        <div class="inputLine">
          <div class="label">线上名称：</div>
          <el-input style="width: 300px" v-model="onlineName"></el-input>
        </div>
        <div class="inputLine" style="margin: 0">
          <div class="label">线上分类：{{ onlineCategoryInfo }}</div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="inputBox_title">商品信息</div>
      <div class="inputBox2">
        <div class="inputLine">
          <div class="label">真实总销量： {{ saleCount }}</div>
        </div>
        <div class="inputLine">
          <div class="label">商品排序：</div>
          <el-input style="width: 200px" v-model.number="sort"></el-input>
        </div>
        <div class="inputLine">
          <div class="label">商品推荐：</div>
          <!-- hsSelect  selectNew -->
          <el-checkbox
            label="花生甄选"
            v-model="hsSelect"
            name="type"
          ></el-checkbox>
          <el-checkbox
            label="甄选上新"
            v-model="selectNew"
            name="type"
          ></el-checkbox>
        </div>
        <div class="tableBox">
          <el-table :data="skuOnlineInfo" style="width: 100%; height: 100%">
            <el-table-column label="排序">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.sort"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="onlineSkuUnitName"
              label="线上规格名称"
              width="200"
            >
            </el-table-column>

            <el-table-column label="规格">
              <template slot-scope="scope">
                {{ scope.row.skuName }}
              </template>
            </el-table-column>
            <el-table-column label="本店库存">
              <template slot-scope="scope">
                {{ scope.row.stockCount }}
              </template>
            </el-table-column>
            <el-table-column label="售价">
              <template slot-scope="scope">
                {{ scope.row.onlineSalePrice }}
              </template>
            </el-table-column>
            <el-table-column label="真实销量">
              <template slot-scope="scope">
                {{ scope.row.saleCount }}
              </template>
            </el-table-column>
            <el-table-column label="虚拟销量">
              <template slot-scope="scope">
                <el-input
                  placeholder="请输入虚拟销量"
                  v-model.number="scope.row.virtualSaleCount"
                  clearable
                  size="small"
                >
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="上架状态">
              <template slot-scope="scope">
                <div v-if="scope.row.appShelves == 0">未上架</div>
                <div v-if="scope.row.appShelves == 1">已上架</div>
                <div v-if="scope.row.appShelves == -1">已下架</div>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handelStartEndClick(scope.row, -1)"
                  v-if="scope.row.appShelves == 1"
                  >下架</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handelStartEndClick(scope.row, 1)"
                  v-if="scope.row.appShelves == 0 || scope.row.appShelves == -1"
                  >上架</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="pageRightBtn">
      <el-button type="primary" @click="handelSubmitClick">提交</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: this.$route.query.id, //对应产品id
      // status: this.$route.query.status, //1商品 2药品 3套餐 4生活服务 5医疗服务 6活体 7虚拟道具 8耗材
      fixedHeight: "",
      dialogImageUrl: "",
      dialogVisible: false,
      title: "",
      brand: "",
      saleCount: 0, //真实销量
      selectNewSort: 0, //商品排序
      sort: -1, //排序
      onlineName: "", //商品名称
      onlineCategoryInfo: "", //线上分类
      guige_info: [], //规格信息
      skuOnlineInfo: [], //sku
      state: 1, //状态
      hsSelect: false,
      selectNew: false,
    };
  },
  mounted() {
    this.getInfoData();
  },
  methods: {
    // sku上下架
    handelStartEndClick(row, status) {
      let params = {
        id: this.id,
        status: status,
        skuId: row.skuId,
        unitId: row.unitId,
        shopId: this.$store.state.shopId,
      };
      // let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_Url_baseData +
            "/api/shop/online/product/update/Sku/AppShelves/status",
          params
        )
        .then((res) => {
          if (res.code == 0) {
            // loading.close()
            if (status == 1) {
              this.$message({
                message: "已上架",
                type: "success",
              });
              // this.getInfoData()
              this.getInfoDatashangjia();
            } else if (status == -1) {
              this.$message({
                message: "已下架",
                type: "error",
              });
              // this.getInfoData()
              this.getInfoDatashangjia();
            }
          }
        });
    },
    handelSubmitClick() {
      let params = {
        productId: this.id, //商品id
        shopId: this.$store.state.shopId,
        hsSelect: this.hsSelect,
        selectNew: this.selectNew,
        sort: Number(this.sort),
        skus: this.skuOnlineInfo,
      };
      this.$http
        .post(
          process.env.VUE_APP_Url_baseData + "/api/shop/online/product/update",
          params
        )
        .then((res) => {
          this.$message({
            type: "success",
            message: "已提交",
          });
          this.$router.back();
        });
    },
    getInfoDatashangjia() {
      let that = this;
      let params = {
        productId: that.id,
        shopId: that.$store.state.shopId,
      };
      this.$http
        .get(
          process.env.VUE_APP_Url_baseData + "/api/shop/online/product",
          params
        )
        .then((res) => {
          const skuOnlineInfo = res.data.skuOnlineInfo;
          if (res.code == 0) {
            skuOnlineInfo.forEach((item, index) => {
              that.skuOnlineInfo[index].appShelves = item.appShelves;
            });
          }
        });
    },
    //获取商品信息
    getInfoData() {
      let that = this;
      let params = {
        productId: that.id,
        shopId: that.$store.state.shopId,
      };
      this.$http
        .get(
          process.env.VUE_APP_Url_baseData + "/api/shop/online/product",
          params
        )
        .then((res) => {
          if (res.code == 0) {
            that.onlineName = res.data.onlineName;
            that.title = res.data.title;
            that.onlineCategoryInfo =
              res.data.onlineCategoryInfo == null
                ? ""
                : res.data.onlineCategoryInfo.name;
            that.skuOnlineInfo = res.data.skuOnlineInfo;
            that.guige_info = res.data.guige_info;
            that.brand = res.data.brand;
            that.saleCount = res.data.saleCount;
            that.selectNewSort = res.data.selectNewSort;
            that.sort = res.data.sort;
            that.hsSelect = res.data.hsSelect;
            that.selectNew = res.data.selectNew;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .pageRightBtn {
    height: 90px;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  padding: 16px 16px 65px 16px;
  height: 100%;
  box-sizing: border-box;
  position: relative;

  .titleLine {
    height: 44px;
    display: flex;
    justify-content: space-between;

    .title {
      font-size: 18px;
      font-weight: 600;
      line-height: 44px;

      &::before {
        content: "";
        display: inline-block;
        width: 5px;
        height: 20px;
        background: rgb(245, 136, 42);
        border-radius: 4px;
        vertical-align: sub;
        margin-right: 12px;
      }
    }

    .titleR {
      .back {
        font-size: 14px;
        color: rgb(245, 136, 42);
        font-weight: 500;
        border-radius: 8px;
        border: 1px solid rgb(245, 136, 42);
        line-height: 42px;
        padding: 0 25px;
        cursor: pointer;
      }
    }
  }

  .content {
    width: 100%;
    background-color: #fff;
    border-radius: 16px;
    padding: 20px 20px;
    box-sizing: border-box;
    margin-top: 16px;

    .inputBox_title {
      font-size: 15px;
      font-weight: 700;
    }

    .inputBox {
      display: flex;
      padding: 0 50px;
      justify-content: space-between;

      .inputLine {
        display: flex;
        margin-bottom: 32px;

        .label {
          font-size: 14px;
          line-height: 40px;
        }
      }
    }

    .inputBox2 {
      .inputLine {
        display: flex;
        margin-bottom: 32px;
        align-items: center;

        .label {
          font-size: 14px;
          line-height: 40px;
        }
      }

      .tableBox {
        padding: 16px;
        border-radius: 8px;
        background-color: #fff;
        box-sizing: border-box;
        margin-top: 16px;
        height: calc(100% - 56px);
      }
    }
  }
}
</style>